<template>
  <div>
    <Heading msg="About Us" />
    <v-row>
      <v-col cols="10" md="7" class="mx-auto">
        <div class="text-center">
          SokoDelivery is an aggregator platform that connects multiple delivery
          companies and various customers. We aim to satisfy an existing market
          niche by providing customers with an easily accessible delivery
          service. By bringing together different delivery companies and
          individuals, SokoDelivery will make the search for a delivery service
          much easier for the end consumer. The platform also aims to reduce the
          fear that arises with entrusting a package with a stranger by
          providing a means of tracing the companies which sign up.
        </div>
      </v-col>
    </v-row>
  </div>
</template>

<script>
// @ is an alias to /src
import Heading from "@/components/Layout/Heading.vue";

export default {
  name: "About",
  components: {
    Heading,
  },
};
</script>
